import script from "./RefugioView.vue?vue&type=script&setup=true&lang=js"
export * from "./RefugioView.vue?vue&type=script&setup=true&lang=js"

import "./RefugioView.vue?vue&type=style&index=0&id=abf9b840&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abf9b840"]])

export default __exports__